import React from 'react';
import DocumentTitle from 'react-document-title';
import PressArchive from '../components/press-page/press-archive-browser/press-archive-browser';

const PressArchiveRoute = () => {
  return (
    <main>
      <DocumentTitle title="Press Archive | NerdWallet" />
      <PressArchive />
    </main>
  );
};

PressArchiveRoute.displayName = 'PressArchiveRoute';
PressArchiveRoute.analyticsName = 'press_archive_page';
PressArchiveRoute.segmentPageName = 'press_archive';

export default PressArchiveRoute;
